import { CSSResultGroup, html, TemplateResult } from 'lit'
import { customElement, query, state } from 'lit/decorators.js'
import { SelectingPaymentMethodEvent } from 'components/ordering/checkout/events.js'
import { paymentMethodSelectable } from 'components/ordering/checkout/payment-methods/payment-methods.style.js'
import {
  SelectPaymentMethodRequest
} from 'components/ordering/checkout/payment-methods/payment-backend/select-payment-method-api.js'
import {
  CSCPaymentMethod,
  PaymentMethodState
} from 'components/ordering/checkout/payment-methods/methods/payment-method.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'

export type TrydentOnAccountData = {
  id: string,
  name: string,
  description: string,
  image_url: string
}

@customElement('csc-on-account')
export class CSCOnAccount extends CSCPaymentMethod {
  static override styles: CSSResultGroup = [hostStyle, paymentMethodSelectable]

  @state() protected readonly paymentMethodId: string
  @state() protected readonly customDescription: string | null
  @state() protected state: PaymentMethodState

  @state() private readonly name: string
  @state() private readonly imageUrl: string

  @query('#start-payment-form')
  private startPaymentForm!: HTMLFormElement

  constructor(data: TrydentOnAccountData, state: PaymentMethodState) {
    super()

    this.state = state
    this.paymentMethodId = data.id
    this.customDescription = data.description
    this.name = data.name
    this.imageUrl = data.image_url
  }

  protected override renderPaymentMethodContent = (): TemplateResult => {
    return html`
      <div class="selectable-content">
        <cse-image
          source="${this.imageUrl}"
          alt="${this.name}"
          width="55"
          height="41"  
        >
        </cse-image>
        <cse-text>${this.name}</cse-text>
        <div hidden>
          <form id="start-payment-form" action="${this.paymentUrlStore.onAccount.startPaymentUrl}" method="post">
            <input type="checkbox" name="action_review" checked>
          </form>
        </div>
      </div>
    `
  }

  protected override selectPaymentMethod = async (): Promise<void> => {
    if (this.state !== 'selectable') { return }

    this.dispatchEvent(new SelectingPaymentMethodEvent(this.paymentMethodId))

    const selectPaymentMethodRequest = new SelectPaymentMethodRequest(
      this.paymentUrlStore.onAccount.selectPaymentMethodUrl,
      this.paymentMethodId,
    )

    await this.paymentBackend.selectPaymentMethod(selectPaymentMethodRequest)
    this.windowLocation.reload()
  }

  protected override startPayment = async (): Promise<void> => {
    if (this.state !== 'selected') { return }

    this.startPaymentForm.requestSubmit()
  }
}
